<section *ngIf="hasNotes" class="order-reminder-notes mb-3" aria-label="Order reminder notes">
	<div class="reminder-header">
		<div class="flex align-items-center gap-2">
			<i class="pi pi-bell"></i>
			<h5 class="m-0">Order Reminders</h5>
		</div>
		<p-tag [value]="notes.length + ' note' + (notes.length === 1 ? '' : 's')" severity="warning" />
	</div>

	<div class="reminder-list">
		<article *ngFor="let note of sortedNotes" class="reminder-note" [class.reminder-note-critical]="note.critical">
			<div class="reminder-note-meta">
				<p-tag [value]="sourceLabel(note)" severity="info" />
				<p-tag *ngIf="note.critical" value="Critical" severity="danger" />
				<span *ngIf="note.createdAt" class="reminder-date">{{ note.createdAt | date: 'short' }}</span>
			</div>
			<div class="reminder-subject">{{ note.subject }}</div>
			<div class="reminder-body" [innerHTML]="note.note | markdown"></div>
		</article>
	</div>
</section>
